
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import SessionGate from "./components/SessionGate";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SessionGate>
          <App />
        </SessionGate>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);